import { render, staticRenderFns } from "./assistanceManage.vue?vue&type=template&id=d9956494&scoped=true"
import script from "./assistanceManage.vue?vue&type=script&lang=js"
export * from "./assistanceManage.vue?vue&type=script&lang=js"
import style0 from "./assistanceManage.vue?vue&type=style&index=0&id=d9956494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9956494",
  null
  
)

export default component.exports